const shareDarkSVG = `
<?xml version="1.0" encoding="utf-8"?>
<!-- Generator: Adobe Illustrator 16.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="84.42px"
 height="89.553px" viewBox="0 0 84.42 89.553" enable-background="new 0 0 84.42 89.553" xml:space="preserve">
<g id="Layer_1">
</g>
<g id="LiveTXT" display="none">
</g>
<g id="GRids">
<g>
<path d="M68.392,57.527c-5.153,0-9.747,2.463-12.681,6.256L31.11,50.041c0.574-1.656,0.89-3.442,0.89-5.285
c0-1.855-0.316-3.625-0.911-5.293l24.579-13.727c2.921,3.809,7.535,6.286,12.703,6.286c8.816,0,16.008-7.182,16.008-16.013
C84.379,7.178,77.202,0,68.371,0c-8.83,0-16.009,7.178-16.009,16.01c0,1.858,0.317,3.646,0.908,5.3L28.709,35.031
c-2.919-3.827-7.531-6.283-12.7-6.283C7.194,28.748,0,35.927,0,44.756c0,8.833,7.199,16.013,16.029,16.013
c5.17,0,9.781-2.474,12.718-6.301l24.582,13.736c-0.595,1.673-0.93,3.481-0.93,5.342c0,8.81,7.179,16.007,16.01,16.007
c8.831,0,16.011-7.18,16.011-16.007C84.42,64.708,77.224,57.527,68.392,57.527z M68.392,5.039c6.06,0,10.987,4.926,10.987,10.992
c0,6.061-4.928,10.99-10.987,10.99c-6.062,0-10.99-4.93-10.99-10.99C57.401,9.965,62.345,5.039,68.392,5.039z M16.029,55.75
c-6.063,0-10.988-4.932-10.988-10.994c0-6.059,4.925-10.988,10.988-10.988c6.062,0,10.988,4.93,10.988,10.988
C27.017,50.818,22.072,55.75,16.029,55.75z M68.392,84.512c-6.062,0-10.99-4.928-10.99-10.986c0-6.063,4.929-10.992,10.99-10.992
c6.06,0,10.987,4.93,10.987,10.992C79.379,79.584,74.451,84.512,68.392,84.512z"/>
</g>
</g>
</svg>

`;

export default shareDarkSVG;



// WEBPACK FOOTER //
// ./src/Components/inlineSVGs/shareDarkSVG.js